import { createContext } from "react"

import type { ImageOverlayPickerConfig } from "./typings"

export type ImageOverlayPickerConfigType = (func: (close: () => void) => ImageOverlayPickerConfig) => void

export const ImageOverlayPickerContext = createContext<ImageOverlayPickerConfigType>(() => {
	throw new Error("No ImageOverlayPickerProvider found")
})
